export const HKP_RETURN_TO = "hkpReturnTo";

const origin = () =>
  String(
    process.env.REACT_APP_LOC_URL ||
      process.env.REACT_APP_DEV_URL ||
      (typeof window !== "undefined" ? window.location.origin : "")
  ).replace(/\/$/, "");

export const studioPiecePath = (productUniqueId: string) =>
  `/studio/p/${encodeURIComponent(String(productUniqueId || "").trim())}`;

export const studioPieceQrUrl = (productUniqueId: string) => {
  const id = String(productUniqueId || "").trim();
  if (!id) {
    return "";
  }
  return `${origin()}${studioPiecePath(id)}`;
};

/** Printed physical QR token. Does not treat a product id or NFC/XUID as a token. */
export const parsePhysicalQrToken = (raw: string): string => {
  const value = String(raw || "").trim();
  if (/^[A-Za-z0-9_-]{22}$/.test(value)) return value;
  const match = value.match(/\/q\/([A-Za-z0-9_-]{22})\/?(?:[?#].*)?$/);
  return match?.[1] || "";
};

export const parseStudioPieceId = (raw: string): string => {
  const value = String(raw || "").trim();
  if (!value) {
    return "";
  }
  const match = value.match(
    /\/studio\/p\/([^/?#]+)|\/product-verifing\/([^/?#]+)|\/product-certification-tantuvi-new\/([^/?#]+)/i
  );
  const captured = match?.[1] || match?.[2] || match?.[3] || "";
  if (!captured) {
    return "";
  }
  try {
    return decodeURIComponent(captured);
  } catch {
    return captured;
  }
};

export const rememberReturnTo = (path: string) => {
  try {
    sessionStorage.setItem(HKP_RETURN_TO, path);
  } catch {
    /* ignore */
  }
};

export const takeReturnTo = (): string => {
  try {
    const path = sessionStorage.getItem(HKP_RETURN_TO) || "";
    sessionStorage.removeItem(HKP_RETURN_TO);
    return path;
  } catch {
    return "";
  }
};
